import appConfig from "../config";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = atob(base64);
    return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

export async function syncPushSubscription() {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
    if (!appConfig.token) return;

    // Если разрешение ещё не выдано — не спрашиваем автоматически
    const permission = Notification.permission === "granted"
        ? "granted"
        : await Notification.requestPermission();
    if (permission !== "granted") return;

    try {
        const reg = await navigator.serviceWorker.ready;

        const res = await fetch(`${appConfig.endpoint}/push/vapid-key`);
        const json = await res.json();
        const publicKey = json.public_key;
        if (!publicKey) return;

        const existing = await reg.pushManager.getSubscription();
        const sub = existing || await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicKey),
        });

        await fetch(`${appConfig.endpoint}/push/subscribe`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${appConfig.token}`,
            },
            body: JSON.stringify(sub.toJSON()),
        });
    } catch (e) {
        console.error("[Push] sync failed:", e);
    }
}